import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'
import writingPitch from '@images/writing-pitch-item.svg'

interface Signature {
  Args: {
    text: string
  }
}

export const WritingPitchLi: TOC<Signature> = <template>
  <li class="flex items-start gap-2">
    <img src={{writingPitch}} alt={{t "pages.accessMissing.writing.coinAlt"}} class="w-8" />
    <span>{{@text}}</span>
  </li>
</template>
